import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import QuizEmbed from '../components/Exercise/QuizEmbed';

export const QuizNode = Node.create({
  name: 'quizNode',
  group: 'block',
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      quizData: {
        default: null,
        parseHTML: element => {
          const data = element.getAttribute('quizData');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing Quiz data from HTML:', e);
              return null;
            }
          }
          return null;
        },
        renderHTML: attributes => {
          if (attributes.quizData) {
            return {
              quizData: JSON.stringify(attributes.quizData)
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      },
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="quiz"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'quiz' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(QuizEmbed);
  },
});

// Создаем отдельную команду для вставки quiz
export const insertQuiz = (attributes) => ({ commands }) => {
  return commands.insertContent({
    type: 'quizNode',
    attrs: attributes,
  });
}; 